import React from 'react';
import { Tooltip } from 'antd';
import { minutesRange } from '../../instruments';

type IShowVoice = {
    valueSec?: string | number | null;
};

export const ShowVoice: React.FC<IShowVoice> = ({ valueSec }: IShowVoice) => {
    const text = minutesRange(valueSec);
    return <Tooltip title={`${valueSec} sec`}>{text}</Tooltip>;
};
